
import React from 'react';
import { createRoot, type Root } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import i18n from '../../../../i18n';
import CostEstimator from '../../../CostEstimator';
import { BaseUrlContext } from './contexts';

export class ReactRootManager {
  private root: Root | null = null;
  
  createRoot(container: HTMLElement): void {
    console.log('[DEBUG] About to create React root in container');
    console.log('[DEBUG] React version:', React.version);
    this.root = createRoot(container);
  }
  
  renderApp(baseUrl: string): void {
    if (!this.root) {
      throw new Error('React root not initialized');
    }
    
    console.log('[DEBUG] About to render React component tree');
    
    const element = React.createElement(
      React.StrictMode,
      null,
      React.createElement(
        BaseUrlContext.Provider, 
        { value: baseUrl },
        React.createElement(
          I18nextProvider,
          { i18n },
          React.createElement(CostEstimator)
        )
      )
    );
    
    console.log('[DEBUG] Created React element structure');
    this.root.render(element);
  }
  
  cleanup(): void {
    if (this.root) {
      try {
        this.root.unmount();
      } catch (e) {
        console.warn('[WARN] Error unmounting React root:', e);
      }
      this.root = null;
    }
  }
}
